<template>
  <img
    src="@/assets/images/coin.webp"
    alt="coin"
  >
</template>